import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import TagManager, { TagManagerArgs } from 'react-gtm-module';

import reportWebVitals from './reportWebVitals';
import ScreensRoot from './screens/Root';

import materialTheme from './theme/materialTheme';
import { envConfigs } from './config/envConfigs';
import { WithAxios } from './helpers/http';
import './index.css';
import { QueryClientProvider, queryClient, QueryDevtools } from './hooks';
import { ToastProvider } from './contexts/ToastContext/ToastContext';
import { CustomerSelectionProvider } from './contexts/CustomerSelectionContext/CustomerSelectionContext';

const tagManagerArgs: TagManagerArgs = {
  gtmId: envConfigs.REACT_APP_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOMClient.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <QueryDevtools initialIsOpen={false} />
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={materialTheme}>
        <CssBaseline />
        <ToastProvider>
          <CustomerSelectionProvider>
            <WithAxios>
              <ScreensRoot />
            </WithAxios>
          </CustomerSelectionProvider>
        </ToastProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </QueryClientProvider>
);

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
